<template>
  <svg
    class="icon"
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <path
      id="Vector"
      fill="currentColor"
      d="M14.5,0H4.5A1.5,1.5,0,0,0,3,1.5V3H1.5A1.5,1.5,0,0,0,0,4.5v10A1.5,1.5,0,0,0,1.5,16h10A1.5,1.5,0,0,0,13,14.5V13h1.5A1.5,1.5,0,0,0,16,11.5V1.5A1.5,1.5,0,0,0,14.5,0ZM11.313,14.5H1.688a.187.187,0,0,1-.187-.187V4.688A.187.187,0,0,1,1.688,4.5H3v7A1.5,1.5,0,0,0,4.5,13h7v1.313a.187.187,0,0,1-.187.188Zm3-3H4.688a.187.187,0,0,1-.187-.187V1.688A.187.187,0,0,1,4.688,1.5h9.625a.187.187,0,0,1,.188.188v9.625a.187.187,0,0,1-.187.188Z"
      transform="translate(16 16) rotate(180)"
    />
  </svg>
</template>
<script setup lang="ts"></script>
